import { CopilotCoreMetrics } from '../../metrics/CopilotMetrics';
import { SECTIONS } from '../DisplayTypes';
export const formatChatspotApiMessage = (apiMessage, source, sourceTemplate) => {
  const type = apiMessage.role ? apiMessage.role.toLowerCase() : 'chatspot';
  const legacyMessageValue = type === 'user' ? apiMessage.message : apiMessage.response;

  // TODO: Once the BE team has removed all the fields associated with legacy
  // rendering and moved all messages into sections we can remove this backfill
  const legacyRendererSectionBackfill = [type === 'user' ? {
    id: 'text',
    type: 'PLAIN_TEXT',
    text: legacyMessageValue
  } : {
    id: 'llmtext',
    text: legacyMessageValue,
    type: 'LLM'
  }];
  const sections = apiMessage.sections || legacyRendererSectionBackfill;
  if (type === 'chatspot' && (!apiMessage.sections || (apiMessage === null || apiMessage === void 0 ? void 0 : apiMessage.sections.length) === 0)) {
    var _apiMessage$query;
    CopilotCoreMetrics.counter('non-section-detected ', {
      isError: String(!!apiMessage.error),
      intent: (_apiMessage$query = apiMessage.query) === null || _apiMessage$query === void 0 ? void 0 : _apiMessage$query.intent
    }).increment();
  }
  const message = Object.assign({}, apiMessage, {
    displayType: SECTIONS,
    response: '',
    sections,
    source,
    sourceTemplate,
    value: '',
    time: apiMessage.created_at || Date.now(),
    type
  });
  return message;
};